export const CompaniesErrors: Record<string, string> = {
  'Unable to delete company. There are links with the employees module':
    'Não foi possível excluir a empresa. Existem vínculos com o módulo de funcionários',
  'Unable to delete company. There are links with the inventory module':
    'Não foi possível excluir a empresa. Existem vínculos com o módulo de inventário',
  'Unable to delete company. There are links with the invoice module':
    'Não foi possível excluir a empresa. Existem vínculos com o módulo de Nota Fiscal',
  'Unable to delete company. There are links with the invoice Settings module':
    'Não foi possível excluir a empresa. Existem vínculos com o módulo de configurações da Nota Fiscal',
  'Unable to delete company. There are links with the purchase module':
    'Não foi possível excluir a empresa. Existem vínculos com o módulo de Compra',
  'Unable to delete company. There are links with the sales module':
    'Não foi possível excluir a empresa. Existem vínculos com o módulo de Venda Direta',
  'Company cannot be deleted due to relation.':
    'Não é possivel excluir a empresa, pois ela tem vínculos com outros módulos',
};
